module.exports = __webpack_public_path__ + "media/images/icons/outlined/folder-open-27b02a1977210cc3091db4fd5da9c840.svg";